(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
        // Footer accordion custom
        var labels = document.querySelectorAll('.acnav-label');

        labels.forEach(function (label) {
            label.addEventListener('click', function () {
                var parent = label.parentElement;
                var list = label.nextElementSibling; // Assuming .acnav-list is a sibling of .acnav-label

                // Close all other .acnav-list elements and remove is-open class
                document.querySelectorAll('.footer-widget').forEach(function (widget) {
                    if (widget !== parent) {
                        widget.classList.remove('is-open');
                        var otherList = widget.querySelector('.acnav-list');
                        if (otherList) {
                            otherList.style.display = 'none';
                        }
                    }
                });

                if (parent.classList.contains('is-open')) {
                    list.style.display = 'none';
                    parent.classList.remove('is-open');
                } else {
                    list.style.display = 'block'; // Adjust this based on your styling
                    parent.classList.add('is-open');
                }
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-tabs"] && !Shopify.designMode) return;
  try {
    
  
  // Tab functionality
  const tabLinks = document.querySelectorAll('.tab-menu li a');

  tabLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const target = link.getAttribute('data-rel');
      tabLinks.forEach(link => link.classList.remove('active'));
      link.classList.add('active');
      
      const targetContent = document.querySelector(`#${target}`);
      const tabContents = document.querySelectorAll('.tab-box');
      tabContents.forEach(content => {
        if (content === targetContent) {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      });
    });
  });

  // Accordion functionality
  document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.custom-accordion-header');

    accordionHeaders.forEach(function(header) {
      header.addEventListener('click', function() {
        const accordion = this.parentNode;
        const isActive = accordion.classList.contains('active');

        closeAllAccordions();

        if (!isActive) {
          accordion.classList.add('active');
          const minusIcon = this.querySelector('.minus-icon');
          const plusIcon = this.querySelector('.plus-icon');
          minusIcon.style.display = 'block';
          plusIcon.style.display = 'none';
        }
      });
    });

    function closeAllAccordions() {
      accordionHeaders.forEach(function(header) {
        const accordion = header.parentNode;
        accordion.classList.remove('active');
        const minusIcon = header.querySelector('.minus-icon');
        const plusIcon = header.querySelector('.plus-icon');
        minusIcon.style.display = 'none';
        plusIcon.style.display = 'block';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      };
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
